<template>
  <div
    class="filters-container flex space-y-8 flex-col items-center md:flex-row md:items-start md:space-y-0"
  >
    <filters-section :simple="true" :type="eventType" />
    <filters-results :simple="true" />
    
  </div>
</template>

<script setup>
import FiltersSection from "@/components/wegow/filters/FiltersSection";
import FiltersResults from "@/components/wegow/filters/FiltersResults";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const eventType = computed(() => {
  if (route.name === "FestivalFilter") {
    return "festivals";
  } else {
    return "concerts";
  }
});
</script>

<style lang="scss" scoped>
.filters-container {
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 100px;
  margin-top: 75px;
}
@media screen and (min-width: 1000px) {
  .filters-container {
    margin-left: 100px;
    margin-right: 100px;
  }
}
@media screen and (min-width: 1400px) {
  .filters-container {
    margin-left: 200px;
  }
}
</style>
